import { ModalHelper } from '../modal-helper';
import { captureMessageForSentry } from '../sentry-helper';

import { AccountModal } from '@/lazy-load-components';

import { ToggleMySportsNotificationPayload } from '@/enums/sports';
import { AccountModes } from '@/enums/login';
import {
	ToggleMySportsNotificationDocument,
	ToggleMySportsNotificationMutation,
	ToggleMySportsNotificationMutationVariables,
} from '@/graphql/mutation/ToggleMySportsNotification.mutation';

import { useMutation } from '@/helpers/composables/useApollo';

export async function toggleMySportsNotification(
	{ eventId, isNotificationActive }: ToggleMySportsNotificationPayload,
	isLoggedIn: boolean
) {
	if (!isLoggedIn) {
		ModalHelper.openModal(
			AccountModal,
			{
				closable: true,
				startScreen: AccountModes.SIGN_UP,
			},
			{ cssClass: 'login-modal' }
		);

		return;
	}

	toggleNotificationMutation(eventId, !isNotificationActive);
}

function toggleNotificationMutation(id: string, state: boolean) {
	const { mutate, onError } = useMutation<
		ToggleMySportsNotificationMutation,
		ToggleMySportsNotificationMutationVariables
	>(ToggleMySportsNotificationDocument, {
		variables: {
			input: {
				id,
				state,
			},
		},
	});

	mutate();

	onError(error =>
		captureMessageForSentry(
			'[GraphQL ToggleMySportsNotification]:',
			{ error, where: 'Helper: sports-notification-helper' },
			'error'
		)
	);
}
